import { render } from "./HiringForm.vue?vue&type=template&id=3afb781a"
import script from "./HiringForm.vue?vue&type=script&lang=js"
export * from "./HiringForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__